import * as React from "react";

const SvgComponent = ({ width ="14px", height = "16px", color = "#FA3C30", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    color={color}
    fill="none"
    {...props}
  >
    <path
      d="M1.75 12.688A1.313 1.313 0 0 0 3.063 14h7.874a1.313 1.313 0 0 0 1.313-1.313V3.5H1.75v9.188Zm7.438-7a.437.437 0 1 1 .874 0v6.125a.438.438 0 0 1-.874 0V5.686Zm-2.626 0a.437.437 0 1 1 .875 0v6.125a.438.438 0 0 1-.875 0V5.686Zm-2.625 0a.437.437 0 1 1 .876 0v6.125a.438.438 0 0 1-.875 0V5.686Zm8.75-4.813h-3.28L9.148.364A.656.656 0 0 0 8.561 0H5.436a.649.649 0 0 0-.585.364l-.257.511H1.312a.437.437 0 0 0-.437.438v.875a.437.437 0 0 0 .438.437h11.374a.438.438 0 0 0 .438-.437v-.876a.438.438 0 0 0-.438-.437Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;